import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { thumb } from "@/lib/media";
import { MediaViewer, PlayIcon } from "./Galeria";

export const M = (n) => `/media/${n}`;

const Slide = ({ m, on, load, first }) => (
  <img className={"hslide" + (on ? " on" : "")} src={load ? thumb(m.id, 1600) : undefined} srcSet={load ? `${thumb(m.id, 900)} 900w, ${thumb(m.id, 1600)} 1600w` : undefined}
    sizes="100vw" alt="" aria-hidden="true" referrerPolicy="no-referrer" fetchPriority={first ? "high" : "auto"} decoding="async" data-testid={`hero-slide-${m.id}`} />
);

const HeroCarousel = () => {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  const [upto, setUpto] = useState(1);
  const [video, setVideo] = useState(false);
  useEffect(() => { api.get("/media/destacados").then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (items.length < 2 || video) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % items.length), cur?.tipo === "video" ? 9000 : 6000);
    return () => clearTimeout(t);
  }, [items.length, video, i]); // eslint-disable-line react-hooks/exhaustive-deps
  const cur = items[i];
  useEffect(() => { setUpto((u) => Math.max(u, i + 2)); }, [i]);
  return (
    <>
      {items.map((m, k) => <Slide key={m.id} m={m} on={k === i} load={k < upto} first={k === 0} />)}
      {cur?.tipo === "video" && (
        <button className="hplay" onClick={() => setVideo(true)} data-testid="hero-video-play-btn"><span className="cplay"><PlayIcon size={26} /></span>Ver video</button>
      )}
      {items.length > 1 && (
        <div className="hdots" role="group" aria-label="Fotos destacadas" data-testid="hero-dots">
          {items.map((m, k) => <button key={m.id} aria-label={`Foto ${k + 1}`} aria-pressed={k === i} onClick={() => setI(k)} data-testid={`hero-dot-${k}`} />)}
        </div>
      )}
      {video && cur && <MediaViewer items={[cur]} index={0} onIndex={() => {}} onClose={() => setVideo(false)} />}
    </>
  );
};

export const Hero = () => (
  <>
    <header className="hero" id="inicio" data-testid="hero-section">
      <img className="poster" src={M("real/hero.webp")} alt="" aria-hidden="true" fetchPriority="high" />
      <HeroCarousel />
      <div className="wrap">
        <span className="pill"><i></i>Psicología del deporte y el alto rendimiento</span>
        <h1 data-testid="hero-title">Formamos campeones dentro y fuera de la cancha</h1>
        <p>Apoyamos el talento local del sur de Barranquilla: deportistas, músicos, artistas y bailarines, con educación emocional, acompañamiento y becas.</p>
        <div className="ctas">
          <a className="btn btn-sol" href="#donar" data-testid="hero-apoyar-btn">Apoyar a un talento</a>
          <a className="btn btn-ghost" href="#juegos" data-testid="hero-jugar-btn">▶ Jugar los 4 retos</a>
        </div>
        <div className="emoji-row" aria-hidden="true">⚽🥋🥊⚾🎮🎶💃🏋️🏄🎸🎻🎯</div>
        <p style={{ fontWeight: 800, color: "var(--sol-l)", margin: "14px 0 0", fontSize: "1.05rem" }}>#ApoyemosElDeporte</p>
      </div>
    </header>
    <div className="stats" data-testid="hero-stats">
      <div className="wrap">
        <div className="stat"><b>+300</b><span>deportistas acompañados en el Atlántico</span></div>
        <div className="stat"><b>+30</b><span>instituciones con resultados positivos</span></div>
        <div className="stat"><b>12</b><span>disciplinas: deporte, arte, música y danza</span></div>
        <div className="stat"><b>100%</b><span>de la utilidad de Sportingtimebq para los atletas</span></div>
      </div>
    </div>
  </>
);

const CARDS = [
  ["boxeo", "Boxeador de la fundación en el ring", "🥊", "Boxeo", "Disciplina, autocontrol y respiración en el ring."],
  ["futbol", "Equipo de fútbol acompañado por la fundación", "⚽", "Fútbol", "Academias del sur de la ciudad y manejo de la presión."],
  ["baloncesto", "Equipo de baloncesto en la cancha", "🏀", "Baloncesto", "Lectura de juego, comunicación y confianza en la cancha."],
  ["atletismo", "Sesión con atletas en la pista", "🏃", "Atletismo", "Constancia, metas y manejo de la ansiedad en la pista."],
  ["voleibol", "Equipo de voleibol de la fundación", "🏐", "Voleibol", "Comunicación y cohesión de equipo en cada punto."],
  ["karate", "Taller con karatecas en el tatami", "🥋", "Karate", "Respeto, concentración y control emocional en el tatami."],
  ["beisbol", "Equipo de béisbol en el campo", "⚾", "Béisbol", "Concentración y lectura del lanzamiento."],
  ["garrocha", "Atletas de salto con garrocha junto a la colchoneta", "🤸", "Salto con garrocha", "Confianza y visualización antes de cada salto."],
  ["gimnasia", "Gimnastas en un taller de la fundación", "🤸‍♀️", "Gimnasia", "Precisión, disciplina y manejo de la presión ante los jueces."],
  ["patinaje", "Niños patinadores de la fundación", "🛼", "Patinaje", "Equilibrio, enfoque y resiliencia sobre ruedas."],
  ["natacion", "Acompañamiento a un deportista junto a la piscina", "🏊", "Natación", "Ritmo, respiración y autoconfianza en el agua."],
  ["pesas", "Charla de la fundación en el gimnasio", "🏋️", "Pesas", "Fuerza mental para el levantamiento perfecto."],
  ["musica", "Jóvenes en un taller de la fundación", "🎶💃", "Música y danza", "Grupos musicales, artistas y casas culturales."],
  ["esports", "Jóvenes en un taller de la fundación", "🎮", "E-sports", "Enfoque y trabajo en equipo frente a la pantalla."],
];

export const Disciplinas = () => (
  <section id="disciplinas" data-testid="disciplinas-section">
    <div className="wrap head reveal">
      <h2>Nuestras disciplinas</h2>
      <p className="lead" style={{ margin: 0 }}>Desliza para conocer a nuestros talentos. <span className="rail-hint">→</span></p>
    </div>
    <div className="rail" tabIndex={0} aria-label="Disciplinas" data-testid="disciplinas-rail">
      {CARDS.map(([img, alt, tag, title, text]) => (
        <article className="card" key={title} data-testid={`disciplina-card-${title}`}>
          <img src={M(`real/${img}.webp`)} alt={alt} loading="lazy" />
          <div><span className="tag">{tag}</span><h3>{title}</h3><p>{text}</p></div>
        </article>
      ))}
    </div>
  </section>
);
